document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll("a[data-href]").forEach(function (link) {
		link.href = link.getAttribute("data-href");
	});
});
